import { component } from 'picoapp';

export default component((node) => {
  const klaviyoModalTriggers = node.querySelectorAll('[data-trigger-modal]');

  klaviyoModalTriggers.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('klaviyo:modal', { detail: { id: item.dataset.triggerModal } }));
    });
  });
});
